import React from "react";
import ProfessorCard from "./ProfessorCard";
import CEOImg from "../assets/ceo.jpg";
import SecondFounderImg from "../assets/2nd-founder.jpg";
import ThirdFounderImg from "../assets/3rd-founder.jpg";

const professors = [
  {
    id: 1,
    image: CEOImg,
    name: "Vũ Việt Dũng",
    position: "Cofounder & CEO",
    bio: 'Vũ Việt Dũng (MBA) là chuyên gia hàng đầu trong quản trị chiến lược và phát triển nhân sự cấp cao với gần 20 năm kinh nghiệm, đặc biệt trong lĩnh vực tài chính ngân hàng. Ông từng là Trưởng phòng, Giám đốc Nhân sự cho các tập đoàn lớn như VPBank, MSB, G-Group, VPS và MCredit. Ông hiện là Chủ tịch KeyPerson (vận hành Khoa Tài chính Ngân hàng của Đại học Đại Nam) và Trưởng Chi nhánh VNHR Miền Bắc, dẫn dắt một trong những tổ chức hàng đầu về tư vấn và đào tạo chiến lược tại Việt Nam. Ông từng tham gia tư vấn, đào tạo cho các tổ chức lớn như USAID, OCB, Vietinbank, Agribank, BIDV... Ông Dũng cũng là tác giả, với hai cuốn sách "Nhân sự là chuyện nhỏ!?" (đã xuất bản) và "Bí mật sếp ngân hàng" (sắp ra mắt).',
    social: {
      linkedin: "#",
      twitter: "#",
      website: "#",
    },
  },
  {
    id: 2,
    image: SecondFounderImg,
    name: "Nguyễn Xuân Hoài",
    position: "Chief AI Scientist",
    bio: "Nguyễn Xuân Hoài là một giáo sư, tiến sỹ, chuyên gia hàng đầu về AI với trên 30 năm kinh nghiệm nghiên cứu, giảng dạy, tư vấn, phát triển công nghệ về AI ở Việt Nam, Australia, và Hàn Quốc. Ông nhận bằng Tiến sỹ (PhD) về AI tại Đại học New South Wales, Australia (#1 của Úc), là một nhà nghiên cứu AI thế hệ tiên phong của Việt Nam, với hàng trăm công trình khoa học, nhận được hơn 3000 trích dẫn trên Google Scholar. Ông là Viện trưởng sáng lập Viện AI Academy Vietnam,  đơn vị đào tạo và phát triển AI đầu tiên của Việt Nam. Ông đã có 10 năm kinh nghiệm thực tế đào tạo, tư vấn chiến lược AI cho nhà nước và các tập đoàn lớn (như Bộ Tài Nguyên Môi Trường, Viettel, EVN, PVN, Vingroup, Vinacomin, Minh Phú, ...). Ông thường xuyên là diễn giả, trưởng ban giám khảo của các sự kiện, giải thưởng lớn về AI ở Việt Nam (như Vietnam DX Summit, giải thưởng Sao Khuê, Top 10 ICT, ...).",
    social: {
      linkedin: "#",
      twitter: "#",
      website: "#",
    },
  },
  {
    id: 3,
    image: ThirdFounderImg,
    name: "David Tran",
    position: "Board Member",
    bio: "David Trần nhận bằng Tiến sỹ từ ĐH Central Florida (Mỹ) và hiện là Giáo sư của ĐH Massachusetts (Mỹ) ngành Khoa học Máy tính với trên 20 năm kinh nghiệm. Ông cũng là Giám đốc (General Partner) của Quỹ đầu tư IDGX Capital chuyên về AI/Blockchain. Trong lĩnh vực AI, nghiên cứu khoa học của ông đang được ứng dụng để tăng hiệu năng tính toán và khả năng mở rộng cho các mô hình AI lớn. Ông đã nhận được 3 giải thưởng Công trình Khoa học Xuất Sắc Nhất ở các hội nghị khoa học quốc tế. Ông còn là một Chuyên gia được mời trong hội đồng xét duyệt của Quỹ Khoa học Quốc Gia của Mỹ. Ở Việt Nam, GS. Trần là thành viên của Viện Nghiên cứu cao cấp về Toán, Phó chủ tịch Hội đồng Viện Công nghệ và Kinh tế số của ĐH Bách Khoa Hà Nội, và đã tham gia làm Giáo sư nghiên cứu tại VinUni và Giám đốc chiến lược về Công nghệ cho tập đoàn Đất Xanh. Ông là khách mời thường xuyên cộng tác với nhiều cơ quan nhà nước, đại học, kênh TV, báo chí trung ương, và doanh nghiệp lớn.",
    social: {
      linkedin: "#",
      twitter: "#",
      website: "#",
    },
  },
];

const ProfessorsSection = () => {
  return (
    <section className="py-0 relative overflow-hidden from-gray-50 via-white to-blue-50">
      {/* Enhanced Background decorative elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-20 right-20 w-80 h-80 bg-brand-primary/10 rounded-full blur-3xl animate-float"></div>
        <div
          className="absolute bottom-20 left-20 w-64 h-64 bg-brand-secondary/10 rounded-full blur-3xl animate-float"
          style={{ animationDelay: "2s" }}
        ></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-brand-dark/5 rounded-full blur-3xl animate-pulse"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-8 relative z-10">
        {/* Enhanced Section Header */}
        <div className="text-center mb-20">
          <h2 className="text-display-3 font-display font-black leading-tight tracking-tighter mb-8">
            <span className="text-brand-dark">Đội ngũ chuyên gia</span>
            <br />
            <span className="text-gradient">hàng đầu</span>
          </h2>
          <p className="text-body-large text-gray-600 max-w-4xl mx-auto leading-relaxed font-body">
            Đội ngũ chuyên gia giàu kinh nghiệm trong lĩnh vực AI và chuyển đổi
            số, cam kết mang đến giải pháp tối ưu cho doanh nghiệp. Chúng tôi tự
            hào có những chuyên gia hàng đầu với kinh nghiệm quốc tế và chuyên
            môn sâu rộng.
          </p>
        </div>

        {/* Enhanced Professors Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20 max-w-6xl mx-auto">
          {professors.map((prof, idx) => (
            <div
              key={prof.id}
              className="animate-fadeIn"
              style={{ animationDelay: `${idx * 0.2}s` }}
            >
              <ProfessorCard {...prof} />
            </div>
          ))}
        </div>

        {/* Enhanced Stats Section */}
        <div className="mb-20">
          <div className="glass rounded-3xl p-8 shadow-xl border border-white/20">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
              <div className="group">
                <div className="text-4xl font-display font-black gradient-text mb-2 tracking-tight">
                  30+
                </div>
                <div className="text-body-small text-gray-600 font-medium tracking-wide">
                  Năm kinh nghiệm
                </div>
              </div>
              <div className="group">
                <div className="text-4xl font-display font-black gradient-text mb-2 tracking-tight">
                  500+
                </div>
                <div className="text-body-small text-gray-600 font-medium tracking-wide">
                  Dự án thành công
                </div>
              </div>
              <div className="group">
                <div className="text-4xl font-display font-black gradient-text mb-2 tracking-tight">
                  100+
                </div>
                <div className="text-body-small text-gray-600 font-medium tracking-wide">
                  Doanh nghiệp đối tác
                </div>
              </div>
              <div className="group">
                <div className="text-4xl font-display font-black gradient-text mb-2 tracking-tight">
                  99%
                </div>
                <div className="text-body-small text-gray-600 font-medium tracking-wide">
                  Khách hàng hài lòng
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Enhanced CTA Section */}
        {/* <div className="text-center">
          <div className="glass rounded-3xl p-12 shadow-xl border border-white/20 mb-8">
            <h3 className="text-h3 font-display font-bold gradient-text mb-4 tracking-tight">
              Sẵn sàng chuyển đổi doanh nghiệp của bạn?
            </h3>
            <p className="text-body-large text-gray-600 mb-8 max-w-2xl mx-auto font-body">
              Hãy để đội ngũ chuyên gia hàng đầu của chúng tôi giúp bạn xây dựng chiến lược AI và chuyển đổi số hiệu quả.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button className="btn-primary text-button font-semibold tracking-wide">
                <span className="flex items-center justify-center">
                  Tư vấn miễn phí
                  <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                  </svg>
                </span>
              </button>
              <button className="btn-secondary text-button font-semibold tracking-wide">
                <span className="flex items-center justify-center">
                  Xem tất cả chuyên gia
                  <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                  </svg>
                </span>
              </button>
            </div>
          </div>
        </div> */}
      </div>
    </section>
  );
};

export default ProfessorsSection;
